import { computed, type ComputedRef } from 'vue-demi';
import { useFegoPageInfo } from '@ark/web-shared';

function fallbackIsEn(): ComputedRef<boolean> {
  return computed(() => false);
}

/** 当前宿主语言是否为英文（web-shared：langText === 'en-us'）。 */
export function readIsEn(): boolean {
  try {
    const { isEN } = useFegoPageInfo();
    return Boolean(isEN.value);
  } catch {
    return false;
  }
}

export function useNupLang() {
  try {
    const { isEN } = useFegoPageInfo();
    return { isEn: isEN };
  } catch {
    return { isEn: fallbackIsEn() };
  }
}
